<div id="silentAuctionContainer" class="silentAuction">
    <div class="inner-container" style="min-height: 100vh;" *ngIf="auction">
        <div class="row slide-show-header justify-content-left d-flex justify-content-between">
            <div class="d-flex align-items-center">
                <div class="text-center mr-2">
                    <div>
                        <img [src]="orgLogo" class="org-icon" [alt]="orgName">
                    </div>
                </div>
                <div class="text-left d-flex flex-column" style="padding-right: 0">
                    <div class="row justify-content-center">
                        <div class="col col--padding">
                            <span class="auction-title">{{orgName}}</span>
                        </div>
                        <div class="col-12 col--padding  status-container d-flex align-items-baseline">
                            <ng-container [ngSwitch]="auctionStatus">
                                <ng-container *ngSwitchCase="0">
                                    <i id="" class="statusIcon green-text run-status fas fa-circle mr-2 d-flex align-items-center"></i>
                                    <div class="run-status green-text" >LIVE</div>
                                </ng-container>
                                <ng-container *ngSwitchCase="1">
                                    <i id="" class="statusIcon yellow-text run-status fas fa-circle mr-2 d-flex align-items-center"></i>
                                    <div class="run-status yellow-text" >PAUSED</div>
                                </ng-container>
                                <ng-container *ngSwitchCase="2">
                                    <i id="" class="statusIcon red-text run-status fas fa-circle mr-2 d-flex align-items-center"></i>
                                    <div class="run-status red-text" >ENDED</div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <i id="" class="statusIcon green-text run-status fas fa-circle mr-2 d-flex align-items-center"></i>
                                    <div class="run-status green-text">LIVE</div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="auction &&  isShowPauseCounter && auctionStatus !== 2">
                <app-counter [campaign]="auction"  (toggleBtn)="toggleStatus($event)"  [mode]="4" [customStyles]="'adaptive-font-size'" class="d-flex align-items-center"></app-counter>
            </ng-container>
        </div>
        <div id="actionContainer" *ngIf="option">
            <hr class="delimeter">
            <div class="auction-body">
                <div class="row row--margin w-100 headers-row row--margin">
                    <div class="col-12 col-md-6 col-xl-7 col--padding images event-title overflow-hidden">
                        <span>{{option.name}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-xl-5 col--padding donors-title mt-md-0">
                        <span *ngIf='option.currentBid !== 0 && !option.buyItNowOnlyItem'  class="donors-header">Current bid: {{getCorrectAmount(option.currentBid)}}</span>
                        <span *ngIf='option.currentBid == 0 && !option.buyItNowOnlyItem' class="donors-header">Starting bid: {{getCorrectAmount(option.minBid)}}</span>
                        <span *ngIf='option.buyItNowOnlyItem' class="donors-header">Buy it now: {{getCorrectAmount(option.buyItNowAmount)}}</span>
                    </div>
                </div>

            <div class="row row--margin main-info-row row--margin w-100">
                    <div [ngClass]="swiperClassList" class="images col-12 col--padding h-100">
                        <div id="slides-" class="event__slides slides-carousel slide-show-swiper-wrapper px-0 h-100" >
                            @if (swiper == 1){
                                <app-slide-show-swiper [optionImages]="optionImages" [configType]="swiperConfig"></app-slide-show-swiper>
                            }
                            @if (swiper == 0){
                                <app-slide-show-swiper [optionImages]="optionImages" [configType]="swiperConfig"></app-slide-show-swiper>
                            }
                        </div>
                    </div>
                    <div *ngIf="showBidHistory" class="donors col-12 col-md-6 col-xl-5 col--padding mt-3 mt-md-0 h-100">
                        <div class="donor-container" *ngFor ='let bid of bids;let i = index;' > 
                            <div class="donor-type icon">
                                <div *ngIf="!bid.winningBid" class="virtual"></div>
                                <div *ngIf="bid.winningBid" class="winning">
                                    <i *ngIf="bid.winningBid" class='fas fa-trophy pr-1 donor-type' style='color: #ffab40;'></i>
                                 </div> 
                            </div>  
                            <div class="price">
                                <div class="activity-type amount text-truncate">Bid of {{getCorrectAmount(bid.amount)}}</div>
                            </div>
                            <div class="username">{{bid.userInfo.name}}</div>              
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isShowError" class="w-100 h-100 position-relative">
        <span class="white-text auction-error">This auction is currently not active</span>
    </div>
</div>
<nav class="navbar fixed-bottom silentAuctionBigScreenBottomNav">
    <div class="row row--margin w-100 mr-0 ml-0 d-flex justify-content-center">
        <div class="col-6 col-sm-4 col--padding align-self-center text-center pr-0 pl-0">
            <div style="align-items:center">
                <img src="/images/footer_powered_by.png" style="height:35px">
            </div>
        </div>
    </div>
</nav>

<a *ngIf="auction" [href]="optionUrl" target="_blank" class="qr-code-link">
    <img src="images/scan_bid_done.png" style="width: 18vh; margin: 0.5rem 0;">
    <div style="display: flex;flex-wrap: nowrap;">
        <img class="images" style="height: 15vh; width: 15vh;" [src]="qrUrl" />
        <img style="height:15vh; margin: 0 0.5rem" src="images/powered_by_paybee2x.png">
    </div>
</a>
